import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StreakStateService } from '../shared/services/streak-state.service';

export const resultsGuard: CanActivateFn = (route, state) => {
  const streakState = inject(StreakStateService);
  const router = inject(Router);

  const hasResult = !!streakState.lastSpinResult();

  if (!hasResult) {
    router.navigate(['/'], {
      queryParams: route.queryParams,
    });
    return false;
  }

  return true;
};
